$(document).ready(function () {
    new Swiper('.swiper-home-outdoor-indoor-slides', {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        pagination: {
            el: '.swiper-pagination-home-outdoor-indoor-slides',
            clickable: true
        },
    });

    new Swiper('.swiper-home-marketing-points-slides', {
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination-home-marketing-points-slides",
            clickable: true
        },
    });

    new Swiper('.swiper-home-three-steps-slides', {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination-home-three-steps-slides',
            clickable: true
        },
    });

    /* HERO START */
    let portraitOrientation = window.matchMedia("(orientation: portrait)")
    let startingWidth = $(window).width();

    loadHeroVideoSrc()

    portraitOrientation.addEventListener('change', function () {
        loadHeroVideoSrc();
    });

    window.addEventListener('resize', function () {
        let currentWidth = $(window).width();

        if (currentWidth !== startingWidth) {
            loadHeroVideoSrc();

            startingWidth = $(window).width();
        }
    });
    /* HERO END */
});

function loadHeroVideoSrc() {
    let videoHolderWidth = $('#hero-video-holder').width();

    let heroVideo = document.getElementById('hero-video');

    let heroVideoBasePath = '/storage/video/';

    if (videoHolderWidth <= 480) {
        heroVideo.src = heroVideoBasePath + 'home-hero-final-480w-compressed.mp4';
    } else if (videoHolderWidth > 480 && videoHolderWidth <= 912) {
        heroVideo.src = heroVideoBasePath + 'home-hero-final-912w-compressed.mp4';
    } else {
        heroVideo.src = heroVideoBasePath + 'home-hero-final-1920w-compressed.mp4';
    }

    heroVideo.load();
}
